import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { Client } from 'api';
import { Button, SelectInput } from 'components/forms';
/* eslint no-unused-vars: 0 */
import css from 'get_started_flow.scss';

export default class extends React.Component {
    api = new Client();
    state = {
        show: false,
        regions: [],
        params: {
            location: null,
            event_type: null,
            capacity: null,
        },
    };

    componentWillMount() {
        const links = document.getElementsByClassName('get-started-link');
        Array.from(links).forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                this.setState({ show: true });
            });
        });

        this.api.request(`/api/regions`, {
            method: 'GET',
            success: (response) => {
                this.setState({ regions: response });
            },
        });
    }

    toggleShown = () => {
        this.setState({ show: !this.state.show });
    };

    setParam = (field, value) => {
        const params = this.state.params;
        params[field] = value;
        this.setState({ params: params });
    };

    locationChanged = ({ value }) => {
        this.setParam('location', value);
    };

    eventTypeChanged = ({ value }) => {
        this.setParam('event_type', value);
    };

    capacityChanged = ({ value }) => {
        this.setParam('capacity', value);
    };

    canSubmit = () => {
        return this.state.params.location === null || this.state.params.event_type === null || this.state.params.capacity === null;
    };

    onSubmit = () => {
        const params = [];
        Object.keys(this.state.params).forEach(key => {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(this.state.params[key]));
        });

        window.location.href = `/results?${params.join('&')}`;
    };

    render() {
        return (
            <Modal show={this.state.show} onHide={this.toggleShown} dialogClassName="revelr-modal">
                <div className="progress-container" />

                <Modal.Header closeButton>
                    <span className="modal-title">Tell Us More About Your Event</span>
                </Modal.Header>

                <div className="modal-body">
                    <SelectInput
                        label="Location"
                        value={this.state.params.location}
                        onChange={this.locationChanged}
                        options={this.state.regions.map(region => {
                            return {
                                value: region.id,
                                label: region.name,
                            };
                        })}
                    />

                    <SelectInput
                        label="Type of Event"
                        value={this.state.params.event_type}
                        onChange={this.eventTypeChanged}
                        options={[{
                            value: 'Wedding/Gala',
                            label: 'Wedding/Gala',
                        }, {
                            value: 'Cocktail Reception',
                            label: 'Cocktail Reception',
                        }, {
                            value: 'Lecture/Panel',
                            label: 'Lecture/Panel',
                        }, {
                            value: 'Meeting',
                            label: 'Meeting',
                        }, {
                            value: 'Bar Mitzvah',
                            label: 'Bar Mitzvah',
                        }, {
                            value: 'Conference',
                            label: 'Conference',
                        }, {
                            value: 'Baby Shower',
                            label: 'Baby Shower',
                        }, {
                            value: 'Rehearsal Dinner',
                            label: 'Rehearsal Dinner',
                        }, {
                            value: 'Team-Building Retreat',
                            label: 'Team-Building Retreat',
                        }, {
                            value: 'Pop-Up Shop',
                            label: 'Pop-Up Shop',
                        }, {
                            value: 'Photoshoot',
                            label: 'Photoshoot',
                        }, {
                            value: 'Fashion Show',
                            label: 'Fashion Show',
                        }, {
                            value: 'Children\'s Event',
                            label: 'Children\'s Event',
                        }, {
                            value: 'Other',
                            label: 'Other',
                        }]}
                    />

                    <SelectInput
                        label="Expected Headcount"
                        value={this.state.params.capacity}
                        onChange={this.capacityChanged}
                        options={[{
                            value: 1,
                            label: '1 - 50',
                        }, {
                            value: 50,
                            label: '51 - 200',
                        }, {
                            value: 200,
                            label: '201 - 500',
                        }, {
                            value: 500,
                            label: '500+',
                        }]}
                    />
                </div>

                <div className="modal-footer">
                    <Button
                        onClick={this.onSubmit}
                        disabled={this.canSubmit()}
                        submitLabel="See Venues"
                    />
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/GetStartedModal.jsx